import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import Spinner from '@/components/ui/spinner';

export default function AuthCallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/', { replace: true });
    } else if (auth.error) {
      console.error('OIDC authentication error:', auth.error);
    }
  }, [auth.isAuthenticated, auth.error, navigate]);

  if (auth.error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-80 space-y-4 px-4 text-center">
        <div className="text-red-500 text-sm font-medium max-w-md">{auth.error.message}</div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-80">
      <Spinner />
    </div>
  );
}
